import styled, { css } from 'styled-components'
import {
  customizeVerticalScrollbarThumbMixin,
  disableSomeContentStyles
} from 'styles/mixins'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const Container = styled.section<{
  $disabled?: boolean
  $isLoading?: boolean
}>`
  width: 100%;
  height: 100%;
  padding-top: 18px;
  display: flex;
  flex-direction: column;
  position: relative;

  ${({ $disabled }) =>
    $disabled &&
    css`
      ${disableSomeContentStyles(0.5)}
    `}
`

export const ItemsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  overflow: hidden;
  align-content: flex-start;
  justify-content: flex-start;
  overflow-y: auto;
  ${customizeVerticalScrollbarThumbMixin()}

  &::after {
    content: '';
    max-width: 164px;
    width: 100%;
  }

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    justify-content: flex-start;

    &::after {
      max-width: 48%;
    }
  }
`
